var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hooper',_vm._b({},'hooper',_vm.$attrs,false),_vm._l((_vm.images),function(item,index){return _c('slide',{key:index},[_c('img',{attrs:{"src":item.src,"width":"76","height":"76"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }